<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="800px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Create/Edit Silk </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="closeDialog" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-row no-gutters justify="space-between">
            <v-col cols="7">
              <v-text-field
                :disabled="fragmentDisabled"
                outlined
                class="mt-1"
                label="Fragment"
                dense
                :value="fragment.toLowerCase()"
                @keyup="fragment = $event.target.value.toLowerCase()"
                :rules="[rules.required]">
              </v-text-field>
              <v-select v-model="section" outlined label="Section" dense :items="items" @change="loadShapes()" :rules="[rules.sectionRequired]"></v-select>
              <v-text-field
                :disabled="fragment === ''"
                outlined
                class="mt-1"
                label="Copy settings from"
                dense
                :value="styleCopied.fragment || ''"
                @click="stylesModal = true">
              </v-text-field>
              <!-- <v-autocomplete :disabled="fragment === ''" outlined label="Copy Settings hello" dense :items="getStyles" item-text="fragment" v-model="styleCopied" @click="stylesModal = true" return-object clearable></v-autocomplete> -->
              <v-row no-gutters>
                <v-col cols="10">
                  <div><strong>Style type:</strong></div>
                  <v-radio-group v-model="styleSelected" row @change="updateColorValue" style="margin-top: 10px !important; padding-top: 0px !important;">
                    <v-radio
                      label="Solid Colour"
                      value="solidColour"
                    ></v-radio>
                    <v-radio
                      label="Pattern"
                      value="pattern"
                    ></v-radio>
                  </v-radio-group>
                  <v-text-field v-if="styleSelected === 'solidColour'"  v-model="fontHex" outlined :label="styleSelected === 'pattern' ? 'Style' : 'Colour'" dense :disabled="styleSelected === 'pattern'" hide-details></v-text-field>
                  <div class="d-inline" v-if="styleSelected === 'pattern'"><v-icon small>mdi-asterisk</v-icon> Indicates shape includes 2 colors</div>
                  <div style="display: flex; margin-top: 12px;" v-if="styleSelected === 'pattern'">
                    <v-autocomplete v-model="shape" outlined label="Shape" dense style="margin-right: 10px;" :items="shapes" item-text="name" return-object clearable @change="copyShape()" hide-details :disabled="Object.keys(this.styleCopied).length !==0"></v-autocomplete>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="#ea0b7c"
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          fab
                          @click="openCreateShapeModal"
                        >
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Create Shape</span>
                    </v-tooltip>
                  </div>
                  <v-checkbox v-if="shape !== null" label="Render with Main Color" v-model="renderWithBaseColor" @change="updateDefsForPreview"></v-checkbox>
                  <v-menu v-if="(styleSelected === 'pattern' && !renderWithBaseColor && shape !== null)" v-model="menuBaseColour" top nudge-bottom="200" nudge-left="200" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn small v-on="on" class="white--text ml-2" color="blue">
                        Base Color
                        <v-icon class="ml-2" small>mdi-format-color-fill</v-icon>
                      </v-btn>
                    </template>
                    <v-card style="height:600px;">
                        <SetColors :sendFont="updateBaseColour"/>
                    </v-card>
                  </v-menu>
                  <v-menu v-if="(styleSelected === 'pattern' && shape !== null)" v-model="menuShapeColour" top nudge-bottom="200" nudge-left="200" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn small v-on="on" class="white--text ml-2" color="blue" :style="shape === null ? 'margin-top: 12px; margin-bottom: 12px;' : ''">
                        Shape Color
                        <v-icon class="ml-2" small>mdi-shape</v-icon>
                      </v-btn>
                    </template>
                    <v-card style="height:600px;">
                        <SetColors :sendFont="updateShapeColour"/>
                    </v-card>
                  </v-menu>
                  <v-menu v-if="(styleSelected === 'pattern' && shape !== null && shape.twoColors)" v-model="menuSecondaryShapeColour" top nudge-bottom="200" nudge-left="200" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn small v-on="on" class="white--text ml-2" color="blue" :style="shape === null ? 'margin-top: 12px; margin-bottom: 12px;' : ''">
                        Secondary Color
                        <v-icon class="ml-2" small>mdi-shape</v-icon>
                      </v-btn>
                    </template>
                    <v-card style="height:600px;">
                        <SetColors :sendFont="updateSecondaryShapeColour"/>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col v-if="styleSelected === 'solidColour'" cols="1" class="pl-2" style="padding-top: 76px;">
                  <v-menu v-model="menu" top nudge-bottom="200" nudge-left="200" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <div :style="swatchStyle" v-on="on" style="border: solid 1px black;"/>
                    </template>
                    <v-card style="height:600px;">
                        <SetColors :sendFont="sendFont"/>
                    </v-card>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 50">
                <defs v-html="defsForPreview"></defs>
                <g>
                  <polygon fill="#010202" points="8.562 50 24.678 50 24.678 46.588 8.562 46.588"></polygon>
                  <path class="default sleeves" :style="section === 'all' ? colorForPreview : section === 'sleeves' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M27.8087,50 L24.2977,50 C24.2977,50 23.8087,42.914 24.2977,41.564 C24.7867,40.216 24.9027,25.472 24.7157,25.216 C24.5307,24.96 25.5687,25.239 25.9447,28.426 C26.3207,31.611 26.8317,33.82 27.1347,34.564 C27.4367,35.309 28.0877,42.877 27.8087,50"></path>
                  <path class="default torso" :style="section === 'all' ? colorForPreview : section === 'torso' ? (styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')') : 'fill:#fff'" d="M24.7979,24.751 C23.5069,22.169 19.2689,20.705 19.2689,20.705 L18.0299,21.123 L17.5069,21.123 C13.9289,19.263 9.0889,18.169 9.0889,18.169 C8.4839,18.169 0.4839,19.239 0.4839,27.519 C0.4839,35.798 3.0419,47.564 3.5999,47.844 C4.1579,48.123 14.0189,48.03 17.6929,48.03 C17.6929,48.03 25.4949,48.437 25.7039,46.658 C25.7039,44.32 26.0879,27.332 24.7979,24.751"></path>
                  <g transform="translate(0, 22)">
                    <path class="default sleeves" :style="section === 'all' ? colorForPreview : section === 'sleeves' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M3.5303,28 C3.5303,28 2.9023,27.007 2.5763,26.704 C2.2513,26.402 1.7393,24.658 1.7623,24.123 C1.7853,23.588 1.2973,21.309 0.9023,20.658 C0.5073,20.007 -0.3537,16.076 0.1573,11.635 C-0.2377,7.867 -0.2377,1.077 5.5763,0.681 C11.3903,0.286 11.4133,7.239 10.7853,10.426 C10.1573,13.611 9.9713,14.681 9.2973,14.867 C8.6233,15.054 8.9023,16.402 9.0883,16.588 C9.2743,16.774 9.6463,17.774 9.1813,18.332 C8.7163,18.891 8.0413,19.379 8.5303,20.007 C9.0183,20.635 10.2743,25.053 9.9253,25.867 C9.5763,26.681 10.2273,28 10.2273,28 L3.5303,28 Z"></path>
                  </g>
                  <g transform="translate(9, 0)">
                    <path class="default cap" :style="section === 'all' ? colorForPreview : section === 'cap' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M8.0626,4.7856 C10.9276,4.7856 13.4606,5.7056 15.0446,7.1196 C14.6946,3.1266 11.5136,-0.0004 7.6376,-0.0004 C3.5266,-0.0004 0.1936,3.5156 0.1936,7.8516 C0.1936,7.9306 0.2036,8.0076 0.2056,8.0856 C1.5976,6.1376 4.5876,4.7856 8.0626,4.7856"></path>
                  </g>
                  <path d="M24.0801,7.8521 C24.0801,7.6051 24.0661,7.3611 24.0451,7.1201 C22.4611,5.7061 19.9281,4.7861 17.0621,4.7861 C13.5871,4.7861 10.5981,6.1371 9.2051,8.0851 C9.2181,8.5591 9.2651,9.0241 9.3541,9.4731 C9.6821,9.0591 10.0921,8.6801 10.5561,8.3321 C10.6871,8.2941 11.6951,8.0241 11.7271,8.6111 C11.7631,9.2391 11.2971,10.3551 11.1281,10.6231 C10.9601,10.8911 10.5401,11.9601 10.5291,12.2271 C10.5181,12.4951 9.9371,13.2741 9.8321,13.4141 C9.7271,13.5531 10.9251,14.9141 11.2391,14.8551 C11.5531,14.7971 11.3911,14.5301 11.4491,13.7741 C11.5071,13.0191 11.9601,10.7051 12.4721,10.1931 C12.9791,9.6851 12.8811,7.3551 12.7711,7.1401 C14.0381,6.6611 15.4981,6.3791 17.0621,6.3791 C17.9761,6.3791 18.8511,6.4811 19.6781,6.6551 C19.9151,6.7531 21.0861,7.2601 21.2741,7.7511 C21.4831,8.2971 21.5181,8.9021 21.5071,9.0301 C21.4951,9.1581 21.3791,14.4831 21.2861,14.5651 C21.1921,14.6461 19.8671,15.7511 19.9721,16.1231 C20.0761,16.4951 20.5641,17.0411 20.8551,16.7971 C21.1461,16.5531 22.1921,15.8321 21.9721,15.1691 C21.7511,14.5071 21.7161,10.6231 22.1351,10.1931 C22.5481,9.7681 23.7101,8.6571 23.7421,8.4721 C23.8391,8.5501 23.9441,8.6231 24.0351,8.7041 C24.0631,8.4241 24.0801,8.1401 24.0801,7.8521" fill="#010202"></path>
                  <polygon class="default collar" :style="section === 'all' ? colorForPreview : section === 'collar' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" points="18.0303 18.9253 18.0303 21.1233 19.2683 20.7043 19.2683 17.6873"></polygon>
                  <path class="default collar" :style="section === 'all' ? colorForPreview : section === 'collar' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M17.5069,18.5879 C17.5069,18.5879 12.9029,15.7049 12.4369,15.7049 C11.9719,15.7049 10.9489,16.0299 10.9489,17.1929 C10.9489,18.3559 9.6929,18.1699 9.0889,18.1699 C9.0889,18.1699 13.9289,19.2629 17.5069,21.1229 L17.5069,18.5879 Z"></path>
                </g>
              </svg>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-textarea outlined label="Defs" v-model="defs" style="margin-top: 16px !important; padding-top: 4px !important;" hide-details></v-textarea>
              <v-btn v-if="defs !== ''" small class="white--text" color="blue" style="margin-top: 12px; margin-bottom: 12px;" @click="replaceDefsForPreview">Update SVG preview</v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <div class="d-inline">
                <v-btn :style="defs === '' ? 'margin-top: 12px;' : ''" v-if="this.fragmentSelected !== ''" small class="white--text" color="success" @click="handleCreateEditStyle(true)" :disabled="this.fragment === '' || this.section === null">Save & Regenerate</v-btn>
                <v-btn :style="defs === '' ? 'margin-top: 12px;' : ''" v-else small class="white--text" color="success" @click="handleCreateEditStyle(false)" :disabled="this.fragment === '' || this.section === null">Save</v-btn>
              </div>
              <div class="d-inline ml-2">
                <v-btn :style="defs === '' ? 'margin-top: 12px;' : ''" small class="white--text" color="error" @click="closeDialog">Cancel</v-btn>
                
                <v-menu top nudge-bottom="-100" nudge-left="-200" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn :style="defs === '' ? 'margin-top: 12px;' : ''" small class="white--text float-right" v-on="on" color="blue">HEX Color Picker <v-icon class="ml-2" small>mdi-tools</v-icon></v-btn>
                  </template>
                  <v-card style="height:600px;">
                    <SetColors :sendFont="sendFont"/>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmationStyleCreated" max-width="300px">
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Style Created/Edited </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="closeConfirmationStyle" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="padding: 12px;">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 50">
            <defs v-html="defsForPreview"></defs>
            <g>
              <polygon fill="#010202" points="8.562 50 24.678 50 24.678 46.588 8.562 46.588"></polygon>
              <path class="default sleeves" :style="section === 'all' ? colorForPreview : section === 'sleeves' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M27.8087,50 L24.2977,50 C24.2977,50 23.8087,42.914 24.2977,41.564 C24.7867,40.216 24.9027,25.472 24.7157,25.216 C24.5307,24.96 25.5687,25.239 25.9447,28.426 C26.3207,31.611 26.8317,33.82 27.1347,34.564 C27.4367,35.309 28.0877,42.877 27.8087,50"></path>
              <path class="default torso" :style="section === 'all' ? colorForPreview : section === 'torso' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M24.7979,24.751 C23.5069,22.169 19.2689,20.705 19.2689,20.705 L18.0299,21.123 L17.5069,21.123 C13.9289,19.263 9.0889,18.169 9.0889,18.169 C8.4839,18.169 0.4839,19.239 0.4839,27.519 C0.4839,35.798 3.0419,47.564 3.5999,47.844 C4.1579,48.123 14.0189,48.03 17.6929,48.03 C17.6929,48.03 25.4949,48.437 25.7039,46.658 C25.7039,44.32 26.0879,27.332 24.7979,24.751"></path>
              <g transform="translate(0, 22)">
                <path class="default sleeves" :style="section === 'all' ? colorForPreview : section === 'sleeves' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M3.5303,28 C3.5303,28 2.9023,27.007 2.5763,26.704 C2.2513,26.402 1.7393,24.658 1.7623,24.123 C1.7853,23.588 1.2973,21.309 0.9023,20.658 C0.5073,20.007 -0.3537,16.076 0.1573,11.635 C-0.2377,7.867 -0.2377,1.077 5.5763,0.681 C11.3903,0.286 11.4133,7.239 10.7853,10.426 C10.1573,13.611 9.9713,14.681 9.2973,14.867 C8.6233,15.054 8.9023,16.402 9.0883,16.588 C9.2743,16.774 9.6463,17.774 9.1813,18.332 C8.7163,18.891 8.0413,19.379 8.5303,20.007 C9.0183,20.635 10.2743,25.053 9.9253,25.867 C9.5763,26.681 10.2273,28 10.2273,28 L3.5303,28 Z"></path>
              </g>
              <g transform="translate(9, 0)">
                <path class="default cap" :style="section === 'all' ? colorForPreview : section === 'cap' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M8.0626,4.7856 C10.9276,4.7856 13.4606,5.7056 15.0446,7.1196 C14.6946,3.1266 11.5136,-0.0004 7.6376,-0.0004 C3.5266,-0.0004 0.1936,3.5156 0.1936,7.8516 C0.1936,7.9306 0.2036,8.0076 0.2056,8.0856 C1.5976,6.1376 4.5876,4.7856 8.0626,4.7856"></path>
              </g>
              <path d="M24.0801,7.8521 C24.0801,7.6051 24.0661,7.3611 24.0451,7.1201 C22.4611,5.7061 19.9281,4.7861 17.0621,4.7861 C13.5871,4.7861 10.5981,6.1371 9.2051,8.0851 C9.2181,8.5591 9.2651,9.0241 9.3541,9.4731 C9.6821,9.0591 10.0921,8.6801 10.5561,8.3321 C10.6871,8.2941 11.6951,8.0241 11.7271,8.6111 C11.7631,9.2391 11.2971,10.3551 11.1281,10.6231 C10.9601,10.8911 10.5401,11.9601 10.5291,12.2271 C10.5181,12.4951 9.9371,13.2741 9.8321,13.4141 C9.7271,13.5531 10.9251,14.9141 11.2391,14.8551 C11.5531,14.7971 11.3911,14.5301 11.4491,13.7741 C11.5071,13.0191 11.9601,10.7051 12.4721,10.1931 C12.9791,9.6851 12.8811,7.3551 12.7711,7.1401 C14.0381,6.6611 15.4981,6.3791 17.0621,6.3791 C17.9761,6.3791 18.8511,6.4811 19.6781,6.6551 C19.9151,6.7531 21.0861,7.2601 21.2741,7.7511 C21.4831,8.2971 21.5181,8.9021 21.5071,9.0301 C21.4951,9.1581 21.3791,14.4831 21.2861,14.5651 C21.1921,14.6461 19.8671,15.7511 19.9721,16.1231 C20.0761,16.4951 20.5641,17.0411 20.8551,16.7971 C21.1461,16.5531 22.1921,15.8321 21.9721,15.1691 C21.7511,14.5071 21.7161,10.6231 22.1351,10.1931 C22.5481,9.7681 23.7101,8.6571 23.7421,8.4721 C23.8391,8.5501 23.9441,8.6231 24.0351,8.7041 C24.0631,8.4241 24.0801,8.1401 24.0801,7.8521" fill="#010202"></path>
              <polygon class="default collar" :style="section === 'all' ? colorForPreview : section === 'collar' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" points="18.0303 18.9253 18.0303 21.1233 19.2683 20.7043 19.2683 17.6873"></polygon>
              <path class="default collar" :style="section === 'all' ? colorForPreview : section === 'collar' ? styleSelected === 'solidColour' ? colorForPreview : 'fill:url(#'+fragment.replace(/ /g, '-')+')' : 'fill:#fff'" d="M17.5069,18.5879 C17.5069,18.5879 12.9029,15.7049 12.4369,15.7049 C11.9719,15.7049 10.9489,16.0299 10.9489,17.1929 C10.9489,18.3559 9.6929,18.1699 9.0889,18.1699 C9.0889,18.1699 13.9289,19.2629 17.5069,21.1229 L17.5069,18.5879 Z"></path>
            </g>
          </svg>
          <div style="margin-top: 15px; font-size: large;">
            <strong>{{ fragment.charAt(0).toUpperCase() + fragment.slice(1) }}</strong> has now been saved.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <StylesLibrary :stylesModal="stylesModal" @close="stylesModal = false" :selectStyle="selectStyle" :selection="section"/>
    <CreateShapeModal :createShapeModal="createShapeModal" :closeCreateShapeModal="closeCreateShapeModal" :newSection="section" :fragment="fragment.toLowerCase()" :shapeToEdit="null"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import SetColors from './SetColors'
import CreateShapeModal from './CreateShapeModal.vue'
import StylesLibrary from './StylesLibrary.vue'

export default {
  components: {
    SetColors,
    CreateShapeModal,
    StylesLibrary
  },
  props: {
    dialog: Boolean,
    fragmentSelected: String,
    closeStyleDialog: Function
  },
  data: () => ({
    items: ['all', 'sleeves', 'cap', 'collar', 'torso'],
    fragment: '',
    fontHex: '',
    section: null,
    shape: null,
    stylesModal: false,
    color: '',
    menu: false,
    defs: '',
    defsForPreview: '',
    colorForPreview: '',
    renderWithBaseColor: true,
    styleCopied: {},
    fragmentDisabled: false,
    confirmationStyleCreated: false,
    styleSelected: 'solidColour',
    createShapeModal: false,
    menuBaseColour: false,
    menuShapeColour: false,
    menuSecondaryShapeColour: false,
    rules: {
      required: value => !!value || 'Fragment is required',
      sectionRequired: value => !!value || 'Please select a Section to continue',
    }
  }),
  watch: {
    dialog () {
      if (this.fragmentSelected !== '') {
        this.fragment = this.fragmentSelected.trim()
        this.fragmentDisabled = true
        this.styles.forEach(style => {
          if (style.fragment.trim().toLowerCase() === this.fragmentSelected.trim().toLowerCase()) {
            this.styleCopied = style
            this.copySettings()
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['loggedIn', 'styles']),
    ...mapGetters(['getShapes']),
    swatchStyle() {
      const { color, menu } = this
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    getStyles: function () {
      return this.styles
    },
    shapes () {
      const section = this.section
      const shapes = this.getShapes
      if (section !== 'all') {
        const s = shapes.filter(shape => {
          if (shape.twoColors) {
            shape.name = shape.name + ' *'
          }
          if (shape.section === section) return shape
        })
        return s
      }
      return []
    }
  },
  methods: {
    ...mapActions(['fetchStyles', 'createStyle', 'regenerateRaceSilks']),
    loadShapes () {
      const section = this.section
      const allShapes = this.getShapes
      if (section !== 'all') {
        return allShapes.filter(shape => shape.section === section)
      }
      return []
    },
    updateBaseColour (baseColour) {
      let t = 0;
      this.defs = this.defs.replace(/fill="([^"]+)"/g, function (match) {
        t++;
        if (t === 1){
          return `fill="${baseColour}"`
        } else {
          return match
        }
      });
      this.defsForPreview = this.defs
    },
    selectStyle (v) {
      this.styleCopied = v
      this.stylesModal = false
      this.copySettings()
    },
    updateShapeColour (shapeColour) {
      let t = 0;   
      this.defs = this.defs.replace(/fill="([^"]+)"/g, function (match) {
        t++;
        if (t === 2){
          return `fill="${shapeColour}"`
        } else {
          return match
        }
      });
      this.defsForPreview = this.defs
    },
    updateSecondaryShapeColour (secondaryShapeColor) {
      let t = 0;   
      this.defs = this.defs.replace(/fill="([^"]+)"/g, function (match) {
        t++;
        if (t === 3){
          return `fill="${secondaryShapeColor}"`
        } else {
          return match
        }
      });
      this.defsForPreview = this.defs
    },
    copyShape () {
      this.defs = this.shape.defs.replace(/id="([^"]+)"/g, 'id="' + this.fragment.replace(/ /g, '-') + '"')
      this.defsForPreview = this.defs
    },
    openCreateShapeModal () {
      this.createShapeModal = true;
    },
    closeCreateShapeModal () {
      this.createShapeModal = false;
    },
    sendFont (f) {
      this.fontHex = f
      this.colorForPreview = `fill: ${f}`
    },
    updateColorValue () {
      if (this.styleSelected === 'pattern') {
        this.color = 'fill:url(#'+this.fragment.replace(/ /g, '-')+')'
      } else {
        this.color = ''
      }
    },
    copySettings () {
      /*if (!this.fragmentDisabled) {
        this.fragment = this.styleCopied.fragment
      }*/
      if (typeof this.styleCopied === 'undefined' || this.styleCopied === null) {
        this.styleCopied = {}
      }
      if (this.styleCopied.shapeId !== 0) {
        this.shape = this.getShapeById(this.styleCopied.shapeId)
      }
      this.section = this.styleCopied.section
      this.defs = typeof this.styleCopied.defs === 'undefined' ? '' : this.styleCopied.defs
      this.styleSelected = typeof this.styleCopied.defs === 'undefined' ? 'solidColour' : 'pattern'
      this.renderWithBaseColor = typeof this.styleCopied.renderWithBaseColor === 'undefined' ? false : this.styleCopied.renderWithBaseColor
      this.fontHex = typeof this.styleCopied.style === 'undefined' ? '' : this.styleSelected === 'pattern' ? 'fill:url(#'+this.fragment.replace(/ /g, '-')+')' : this.styleCopied.style
      this.colorForPreview = this.fontHex
      this.defsForPreview = this.defs.replace(/id="([^"]+)"/g, 'id="' + this.fragment.replace(/ /g, '-') + '"')
      this.replaceDefsForPreview()
      this.replaceColorForPreview()
    },
    getShapeById (id) {
      const shapes = this.getShapes
      return shapes.filter(shape => shape.id === id)[0]
    },
    replaceDefsForPreview () {
      this.defs = this.defs.replace(/id=""/, 'id="' + this.fragment.replace(/ /g, '-') + '"')
      this.defsForPreview = this.defs.replace(/id="([^"]+)"/, 'id="' + this.fragment.replace(/ /g, '-') + '"')
      // this.defsForPreview = this.defs.replace('{{.ID}}', this.fragment.replace(/ /g, '-'))
      this.updateDefsForPreview()
    },
    updateDefsForPreview () {
      if (this.renderWithBaseColor) {
        this.fontHex = 'fill:url(#'+this.fragment.replace(/ /g, '-')+')'
        // this.defs = this.defs.replace(/id="([^"]+)"/g, 'id="{{.ID}}"')
        // this.defs = this.defs.replace(/fill="([^"]+)"/, 'fill="{{.BaseColor}}"')
        if (this.fragment.includes("white")) {
          this.defsForPreview = this.defsForPreview.replace('{{.BaseColor}}', '#000');
        } else {
          this.defsForPreview = this.defsForPreview.replace('{{.BaseColor}}', '#fff');
        }
      } else {
        if (this.defs !== '') {
          this.fontHex = 'fill:url(#'+this.fragment.replace(/ /g, '-')+')'
          this.defs = this.defs.replace(/id="([^"]+)"/g, 'id="' + this.fragment.replace(/ /g, '-') + '"')
        }
      }
    },
    replaceColorForPreview () {
      if (this.fontHex.includes('fill')) {
        this.colorForPreview = this.fontHex
      } else {
        this.colorForPreview = 'fill:' + this.fontHex
      }
    },
    async handleCreateEditStyle (regenerateSilks) {
      let shapeId = null
      if (this.shape !== null) {
        shapeId = this.shape.id
      }
      await this.createStyle({fragment: this.fragment, section: this.section, style: this.section === 'all' ? this.fontHex : this.styleSelected === 'solidColour' ? this.colorForPreview : this.fontHex, defs: this.defs, renderWithBaseColor: this.renderWithBaseColor, shapeId: shapeId})
      this.closeStyleDialog()
      this.confirmationStyleCreated = true
      this.fetchStyles()
      if (regenerateSilks) {
        this.regenerateRaceSilks()
      }
      setTimeout(() => {
        this.confirmationStyleCreated = false
        this.fragment = ''
        this.section = null
        this.defs = ''
        this.defsForPreview = ''
        this.colorForPreview = ''
        this.color = ''
        this.renderWithBaseColor = true
        this.styleCopied = {}
        this.fragmentDisabled = false
        this.shape = null
        this.fontHex = ''
        this.styleSelected = 'solidColour'
      }, 2000)
      // this.fetchRenderingErrors()
    },
    closeConfirmationStyle () {
      this.confirmationStyleCreated = false
      this.fragment = ''
      this.section = null
      this.defs = ''
      this.defsForPreview = ''
      this.colorForPreview = ''
      this.color = ''
      this.renderWithBaseColor = true
      this.styleCopied = {}
      this.fragmentDisabled = false
      this.shape = null
      this.fontHex = ''
      this.styleSelected = 'solidColour'
    },
    closeDialog () {
      this.confirmationStyleCreated = false
      this.fragment = ''
      this.section = null
      this.defs = ''
      this.defsForPreview = ''
      this.colorForPreview = ''
      this.color = ''
      this.renderWithBaseColor = true
      this.styleCopied = {}
      this.fragmentDisabled = false
      this.shape = null
      this.fontHex = ''
      this.styleSelected = 'solidColour'
      this.closeStyleDialog()
    }
  }
}
</script>
